<template>
  <div class="relative cursor-pointer group">
    <div
      :class="hasBottom ? 'bottom' : 'top'"
      class="absolute text-white transition-all duration-75 bg-pop px-4 translate-x-[-40%] hidden group-hover:flex"
    >
      <div class="z-10">
        <slot />
      </div>
    </div>
    <RequiredIcon
      class="w-3.5 h-3.5 inline text-primary group-hover:text-black"
    />
  </div>
</template>
<script setup>
const props = defineProps({
  hasBottom: {
    type: Boolean,
    default: false,
  },
});
const RequiredIcon = defineAsyncComponent(() =>
  import("@/assets/svg/heroicons/required.svg?component")
);
</script>
<style scoped>
.bg-pop::after {
  content: "";
  background-image: url("/pop-notie.svg");
  @apply w-full h-full absolute left-0 bottom-0 bg-no-repeat bg-contain bg-center transition-all duration-75;
}
.bg-pop.bottom::after {
  content: "";
  @apply rotate-180;
}
.bg-pop.bottom {
  @apply top-full pt-[13px] pb-[5px];
}
.bg-pop.top {
  @apply bottom-full pt-[5px] pb-[13px];
}
</style>